import {
  InstagramLogo, Globe, Target, EnvelopeSimple, Ticket, Handshake,
  CalendarStar, Newspaper, Binoculars, Wallet, UsersThree, AddressBook, FileText,
} from "@phosphor-icons/react";

export const MODULES = {
  social: {
    title: "Social Media",
    subtitle: "Plan, preview and publish across every platform",
    icon: InstagramLogo,
    resource: "social_posts",
    columns: [
      { key: "caption", label: "Post" },
      { key: "platform", label: "Platform" },
      { key: "brand", label: "Brand" },
      { key: "format", label: "Format" },
      { key: "status", label: "Status", type: "status" },
      { key: "reach", label: "Reach", type: "number" },
      { key: "likes", label: "Likes", type: "number" },
    ],
    fields: [
      { name: "caption", label: "Caption", type: "textarea" },
      { name: "platform", label: "Platform", type: "select", options: ["Instagram", "Facebook", "YouTube", "Pinterest", "LinkedIn", "X"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "format", label: "Format", type: "select", options: ["Reel", "Story", "Carousel", "Post"] },
      { name: "status", label: "Status", type: "select", options: ["Draft", "Awaiting approval", "Scheduled", "Published"] },
    ],
  },
  seo: {
    title: "Website & SEO",
    subtitle: "Keywords, rankings and organic performance",
    icon: Globe,
    resource: "seo",
    columns: [
      { key: "keyword", label: "Keyword" },
      { key: "brand", label: "Brand" },
      { key: "position", label: "Position", type: "number" },
      { key: "volume", label: "Volume", type: "number" },
      { key: "traffic", label: "Traffic", type: "number" },
      { key: "difficulty", label: "Difficulty", type: "number" },
      { key: "trend", label: "Trend" },
    ],
    fields: [
      { name: "keyword", label: "Keyword" },
      { name: "brand", label: "Brand", type: "select" },
      { name: "position", label: "Position", type: "number" },
      { name: "volume", label: "Volume", type: "number" },
    ],
  },
  ads: {
    title: "Paid Advertising",
    subtitle: "Meta, Google, YouTube & Pinterest performance",
    icon: Target,
    resource: "ads",
    columns: [
      { key: "name", label: "Ad Set" },
      { key: "platform", label: "Platform" },
      { key: "status", label: "Status", type: "status" },
      { key: "spend", label: "Spend", type: "money" },
      { key: "revenue", label: "Revenue", type: "money" },
      { key: "roas", label: "ROAS" },
      { key: "ctr", label: "CTR", type: "pct" },
    ],
    fields: [
      { name: "name", label: "Ad Set Name", required: true },
      { name: "platform", label: "Platform", type: "select", options: ["Meta Ads", "Google Ads", "YouTube Ads", "Pinterest Ads"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "budget", label: "Budget", type: "number" },
      { name: "spend", label: "Spend", type: "number" },
      { name: "revenue", label: "Revenue", type: "number" },
      { name: "status", label: "Status", type: "select", options: ["Draft", "Pending Approval", "Scheduled", "Active", "Paused", "Completed", "Cancelled"] },
    ],
  },
  messaging: {
    title: "Email, WhatsApp & SMS",
    subtitle: "Lifecycle campaigns across every direct channel",
    icon: EnvelopeSimple,
    resource: "email_campaigns",
    columns: [
      { key: "name", label: "Campaign" },
      { key: "channel", label: "Channel" },
      { key: "type", label: "Type" },
      { key: "status", label: "Status", type: "status" },
      { key: "audience_size", label: "Audience", type: "number" },
      { key: "open_rate", label: "Open", type: "pct" },
      { key: "revenue", label: "Revenue", type: "money" },
    ],
    fields: [
      { name: "name", label: "Campaign Name" },
      { name: "channel", label: "Channel", type: "select", options: ["Email", "WhatsApp", "SMS", "Push"] },
      { name: "type", label: "Type", type: "select", options: ["Welcome series", "New launch", "Cart abandonment", "Festival", "Win-back", "Loyalty"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "status", label: "Status", type: "select", options: ["Draft", "Scheduled", "Sent"] },
    ],
  },
  promotions: {
    title: "Promotions & Coupons",
    subtitle: "Codes, offers and referral rewards",
    icon: Ticket,
    resource: "promotions",
    columns: [
      { key: "code", label: "Code" },
      { key: "type", label: "Type" },
      { key: "brand", label: "Brand" },
      { key: "discount", label: "Discount", type: "pct" },
      { key: "status", label: "Status", type: "status" },
      { key: "orders", label: "Orders", type: "number" },
      { key: "revenue", label: "Revenue", type: "money" },
    ],
    fields: [
      { name: "code", label: "Coupon Code", required: true },
      { name: "type", label: "Type", type: "select", options: ["First-order", "Festival", "Category", "Free shipping", "Loyalty", "Referral", "Flash"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "discount", label: "Discount %", type: "number" },
      { name: "usage_limit", label: "Usage Limit", type: "number" },
      { name: "valid_till", label: "Valid Till", type: "date" },
      { name: "status", label: "Status", type: "select", options: ["Draft", "Scheduled", "Active", "Expired", "Paused", "Cancelled"] },
    ],
  },
  affiliates: {
    title: "Affiliate Marketing",
    subtitle: "Partners, links and commission tracking",
    icon: Handshake,
    resource: "affiliates",
    columns: [
      { key: "name", label: "Affiliate" },
      { key: "code", label: "Code" },
      { key: "commission", label: "Commission", type: "pct" },
      { key: "orders", label: "Orders", type: "number" },
      { key: "revenue", label: "Revenue", type: "money" },
      { key: "conversion", label: "Conv.", type: "pct" },
      { key: "status", label: "Status", type: "status" },
    ],
    fields: [
      { name: "name", label: "Affiliate Name" },
      { name: "code", label: "Affiliate Code" },
      { name: "commission", label: "Commission %", type: "number" },
      { name: "status", label: "Status", type: "select", options: ["Active", "Pending"] },
    ],
  },
  events: {
    title: "Events & Exhibitions",
    subtitle: "Pop-ups, shows, press and trade events",
    icon: CalendarStar,
    resource: "events",
    columns: [
      { key: "name", label: "Event" },
      { key: "type", label: "Type" },
      { key: "brand", label: "Brand" },
      { key: "venue", label: "Venue" },
      { key: "status", label: "Status", type: "status" },
      { key: "budget", label: "Budget", type: "money" },
      { key: "leads", label: "Leads", type: "number" },
    ],
    fields: [
      { name: "name", label: "Event Name" },
      { name: "type", label: "Type", type: "select", options: ["Fashion show", "Pop-up store", "Press event", "Exhibition", "Influencer event"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "venue", label: "Venue" },
      { name: "budget", label: "Budget", type: "number" },
      { name: "status", label: "Status", type: "select", options: ["Planned", "Confirmed", "Completed"] },
    ],
  },
  pr: {
    title: "PR & Media",
    subtitle: "Journalists, publications and coverage",
    icon: Newspaper,
    resource: "pr",
    columns: [
      { key: "contact", label: "Contact" },
      { key: "type", label: "Type" },
      { key: "brand", label: "Brand" },
      { key: "topic", label: "Topic" },
      { key: "status", label: "Status", type: "status" },
      { key: "sentiment", label: "Sentiment", type: "status" },
    ],
    fields: [
      { name: "contact", label: "Contact / Publication" },
      { name: "type", label: "Type", type: "select", options: ["Publication", "Journalist", "Blog"] },
      { name: "brand", label: "Brand", type: "select" },
      { name: "topic", label: "Topic" },
      { name: "status", label: "Status", type: "select", options: ["Pitched", "Interview requested", "Follow-up", "Published"] },
    ],
  },
  competitors: {
    title: "Competitor Intelligence",
    subtitle: "Track rivals, pricing and positioning",
    icon: Binoculars,
    resource: "competitors",
    columns: [
      { key: "name", label: "Brand" },
      { key: "category", label: "Category" },
      { key: "new_launches", label: "Launches", type: "number" },
      { key: "avg_price", label: "Avg Price", type: "money" },
      { key: "social_activity", label: "Social" },
      { key: "positioning", label: "Positioning" },
    ],
    fields: [
      { name: "name", label: "Competitor Name" },
      { name: "category", label: "Category" },
      { name: "positioning", label: "Positioning" },
      { name: "note", label: "Note", type: "textarea" },
    ],
  },
  budgets: {
    title: "Budget & Expenses",
    subtitle: "Plan, approve and track marketing spend",
    icon: Wallet,
    resource: "budgets",
    columns: [
      { key: "name", label: "Budget" },
      { key: "brand", label: "Brand" },
      { key: "category", label: "Category" },
      { key: "planned", label: "Planned", type: "money" },
      { key: "approved", label: "Approved", type: "money" },
      { key: "actual", label: "Actual", type: "money" },
      { key: "roi", label: "ROI" },
    ],
    fields: [
      { name: "name", label: "Budget Name" },
      { name: "brand", label: "Brand", type: "select" },
      { name: "category", label: "Category", type: "select", options: ["Advertising", "Influencers", "Photoshoots", "Events", "Content production", "PR"] },
      { name: "planned", label: "Planned Amount", type: "number" },
    ],
  },
  segments: {
    title: "Customer Segments",
    subtitle: "Auto & custom audiences from your CRM",
    icon: UsersThree,
    resource: "segments",
    refreshable: true,
    columns: [
      { key: "name", label: "Segment" },
      { key: "size", label: "Audience Size", type: "number" },
      { key: "clv", label: "Avg CLV", type: "money" },
      { key: "criteria", label: "Criteria" },
    ],
    fields: [
      { name: "name", label: "Segment Name", required: true },
      { name: "size", label: "Estimated Size", type: "number" },
      { name: "clv", label: "Avg CLV", type: "number" },
      { name: "criteria", label: "Criteria", type: "textarea" },
    ],
  },
  crm: {
    title: "Collaboration CRM",
    subtitle: "Stylists, photographers, agencies & creators",
    icon: AddressBook,
    resource: "influencers",
    columns: [
      { key: "name", label: "Contact" },
      { key: "category", label: "Category" },
      { key: "platform", label: "Platform" },
      { key: "location", label: "Location" },
      { key: "stage", label: "Stage", type: "status" },
      { key: "rate", label: "Rate", type: "money" },
    ],
    fields: [
      { name: "name", label: "Contact Name", required: true },
      { name: "category", label: "Category / Role" },
      { name: "platform", label: "Platform", type: "select", options: ["Instagram", "YouTube", "Pinterest", "X", "Agency", "Studio"] },
      { name: "location", label: "Location" },
      { name: "rate", label: "Rate", type: "number" },
      { name: "stage", label: "Stage", type: "select", options: ["Identified", "Shortlisted", "Contacted", "Negotiation", "Confirmed", "Published"] },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  reports: {
    title: "Reports",
    subtitle: "Build, save and schedule custom reports",
    icon: FileText,
    resource: "reports",
    columns: [
      { key: "name", label: "Report" },
      { key: "type", label: "Type" },
      { key: "owner", label: "Owner" },
    ],
    fields: [
      { name: "name", label: "Report Name" },
      { name: "type", label: "Type", type: "select", options: ["Dashboard", "Table", "Comparison", "Chart"] },
    ],
  },
};
